// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Overlay ─────────────────────────────────────── */
.resampling-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 24px 16px;
}

/* ─── Modal container ─────────────────────────────── */
.resampling-modal {
  background: #ffffff;
  border-radius: 10px;
  width: 540px;
  max-width: 94vw;
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
  overflow: hidden;
}

/* ─── Header ──────────────────────────────────────── */
.resampling-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e9ecef;
  background: #f5f7fb;
}

.resampling-modal-header h3 {
  margin: 0;
  font-size: 17px;
  color: #1c2b61;
}

.resampling-modal-close {
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
  color: #666;
  line-height: 1;
  padding: 0 4px;
}

.resampling-modal-close:hover {
  color: #333;
}

/* ─── Scrollable body ─────────────────────────────── */
.resampling-modal-body {
  padding: 16px 20px;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 14px;
  position: relative;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.resampling-modal-body::-webkit-scrollbar {
  display: none;
}

/* ─── Info banner ─────────────────────────────────── */
.resampling-info-banner {
  background: #eef3ff;
  border: 1px solid #c5d4f7;
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 13px;
  color: #2c3e7a;
  line-height: 1.55;
}

.resampling-info-banner p {
  margin: 0 0 6px;
}

.resampling-info-banner p:last-child {
  margin-bottom: 0;
}

.resampling-dist-hint {
  font-size: 12.5px;
  color: #4a5d9a;
  margin-top: 6px;
}

/* ─── Modal class distribution table ─────────────── */
.resampling-modal-dist {
  margin-top: 10px;
  border-top: 1px solid #d7e2ff;
  padding-top: 10px;
}

.resampling-modal-dist__title {
  font-size: 12.5px;
  font-weight: 600;
  color: #2f4fb5;
  margin: 0 0 7px 0;
}

.resampling-modal-dist__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12.5px;
}

.resampling-modal-dist__table th {
  background: #eef1f8;
  color: #2f4fb5;
  font-weight: 600;
  padding: 5px 9px;
  text-align: left;
  border-bottom: 2px solid #c7d2ef;
}

.resampling-modal-dist__table td {
  padding: 5px 9px;
  border-bottom: 1px solid #e9ecef;
  vertical-align: middle;
}

.resampling-modal-dist__table tr:last-child td {
  border-bottom: none;
}

.resampling-modal-dist__note {
  font-size: 11px;
  color: #6c757d;
  font-style: italic;
  margin: 5px 0 0 0;
}

.resampling-modal-dist__table .resampling-row-minority td {
  background: #fff9f0;
}

.resampling-modal-dist__table .resampling-row-majority td {
  background: #f4faf0;
}

.resampling-modal-dist__table .resampling-synthetic-badge {
  display: inline-block;
  background: #fff3cd;
  color: #7a4f00;
  border: 1px solid #ffe082;
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 11.5px;
  font-weight: 500;
}

.resampling-modal-dist__table .resampling-majority-badge {
  display: inline-block;
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 11.5px;
  font-weight: 500;
}

/* ─── Warning banner ──────────────────────────────── */
.resampling-warning-banner {
  background: #fffbe6;
  border: 1px solid #ffe58f;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 12.5px;
  color: #7d6005;
  line-height: 1.5;
}

/* ─── Pipeline step card ──────────────────────────── */
.resampling-pipeline-step {
  border: 1px solid #d7e2ff;
  border-radius: 8px;
  background: #f9faff;
  overflow: visible;
}

.resampling-step-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 11px 14px;
  background: #eef2ff;
  border-radius: 8px 8px 0 0;
  border-bottom: 1px solid #d7e2ff;
  font-weight: 600;
  font-size: 13.5px;
}

.resampling-step-title {
  font-size: 13.5px;
  font-weight: 600;
  color: #1c2b61;
}

/* ─── Step params ─────────────────────────────────── */
.resampling-step-params {
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.resampling-param-row {
  display: grid;
  grid-template-columns: 160px 1fr;
  align-items: center;
  gap: 12px;
  font-size: 13px;
}

.resampling-param-row label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
}

.resampling-param-row select,
.resampling-param-row input[type='number'] {
  padding: 6px 10px;
  border: 1px solid #cdd6f0;
  border-radius: 6px;
  font-size: 13px;
  background: #fff;
  color: #222;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
}

.resampling-param-row select:focus,
.resampling-param-row input[type='number']:focus {
  outline: none;
  border-color: #5272c2;
  box-shadow: 0 0 0 3px rgba(82, 114, 194, 0.15);
}

/* ─── Footer ──────────────────────────────────────── */
.resampling-modal-footer {
  padding: 14px 20px;
  border-top: 1px solid #e9ecef;
  background: #f5f7fb;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
}

.resampling-footer-buttons {
  display: flex;
  gap: 10px;
}

.resampling-btn-cancel {
  padding: 8px 18px;
  border: 1px solid #cdd6f0;
  border-radius: 6px;
  background: #fff;
  font-size: 13.5px;
  font-weight: 500;
  color: #4a4a6a;
  cursor: pointer;
  transition: background 0.15s;
}

.resampling-btn-cancel:hover {
  background: #eef2ff;
}

.resampling-btn-apply {
  padding: 8px 22px;
  background: #1c2b61;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}

.resampling-btn-apply:hover {
  background: #2a3f8f;
}

.resampling-btn-apply:disabled {
  background: #9aa5c8;
  cursor: not-allowed;
}

/* ─── Body scroll lock ────────────────────────────── */
body.resampling-modal-open {
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/css/ResamplingConfigModal.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,wDAAwD;AACxD;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,wDAAwD;AACxD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA,wDAAwD;AACxD;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,uDAAuD;AACvD;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,wDAAwD;AACxD;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,wDAAwD;AACxD;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,wDAAwD;AACxD;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,wDAAwD;AACxD;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,wDAAwD;AACxD;EACE,gBAAgB;AAClB","sourcesContent":["/* ─── Overlay ─────────────────────────────────────── */\n.resampling-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1100;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 24px 16px;\n}\n\n/* ─── Modal container ─────────────────────────────── */\n.resampling-modal {\n  background: #ffffff;\n  border-radius: 10px;\n  width: 540px;\n  max-width: 94vw;\n  max-height: 88vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);\n  overflow: hidden;\n}\n\n/* ─── Header ──────────────────────────────────────── */\n.resampling-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid #e9ecef;\n  background: #f5f7fb;\n}\n\n.resampling-modal-header h3 {\n  margin: 0;\n  font-size: 17px;\n  color: #1c2b61;\n}\n\n.resampling-modal-close {\n  background: none;\n  border: none;\n  font-size: 22px;\n  cursor: pointer;\n  color: #666;\n  line-height: 1;\n  padding: 0 4px;\n}\n\n.resampling-modal-close:hover {\n  color: #333;\n}\n\n/* ─── Scrollable body ─────────────────────────────── */\n.resampling-modal-body {\n  padding: 16px 20px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  position: relative;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.resampling-modal-body::-webkit-scrollbar {\n  display: none;\n}\n\n/* ─── Info banner ─────────────────────────────────── */\n.resampling-info-banner {\n  background: #eef3ff;\n  border: 1px solid #c5d4f7;\n  border-radius: 8px;\n  padding: 12px 14px;\n  font-size: 13px;\n  color: #2c3e7a;\n  line-height: 1.55;\n}\n\n.resampling-info-banner p {\n  margin: 0 0 6px;\n}\n\n.resampling-info-banner p:last-child {\n  margin-bottom: 0;\n}\n\n.resampling-dist-hint {\n  font-size: 12.5px;\n  color: #4a5d9a;\n  margin-top: 6px;\n}\n\n/* ─── Modal class distribution table ─────────────── */\n.resampling-modal-dist {\n  margin-top: 10px;\n  border-top: 1px solid #d7e2ff;\n  padding-top: 10px;\n}\n\n.resampling-modal-dist__title {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #2f4fb5;\n  margin: 0 0 7px 0;\n}\n\n.resampling-modal-dist__table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12.5px;\n}\n\n.resampling-modal-dist__table th {\n  background: #eef1f8;\n  color: #2f4fb5;\n  font-weight: 600;\n  padding: 5px 9px;\n  text-align: left;\n  border-bottom: 2px solid #c7d2ef;\n}\n\n.resampling-modal-dist__table td {\n  padding: 5px 9px;\n  border-bottom: 1px solid #e9ecef;\n  vertical-align: middle;\n}\n\n.resampling-modal-dist__table tr:last-child td {\n  border-bottom: none;\n}\n\n.resampling-modal-dist__note {\n  font-size: 11px;\n  color: #6c757d;\n  font-style: italic;\n  margin: 5px 0 0 0;\n}\n\n.resampling-modal-dist__table .resampling-row-minority td {\n  background: #fff9f0;\n}\n\n.resampling-modal-dist__table .resampling-row-majority td {\n  background: #f4faf0;\n}\n\n.resampling-modal-dist__table .resampling-synthetic-badge {\n  display: inline-block;\n  background: #fff3cd;\n  color: #7a4f00;\n  border: 1px solid #ffe082;\n  border-radius: 4px;\n  padding: 2px 6px;\n  font-size: 11.5px;\n  font-weight: 500;\n}\n\n.resampling-modal-dist__table .resampling-majority-badge {\n  display: inline-block;\n  background: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n  border-radius: 4px;\n  padding: 2px 6px;\n  font-size: 11.5px;\n  font-weight: 500;\n}\n\n/* ─── Warning banner ──────────────────────────────── */\n.resampling-warning-banner {\n  background: #fffbe6;\n  border: 1px solid #ffe58f;\n  border-radius: 8px;\n  padding: 10px 14px;\n  font-size: 12.5px;\n  color: #7d6005;\n  line-height: 1.5;\n}\n\n/* ─── Pipeline step card ──────────────────────────── */\n.resampling-pipeline-step {\n  border: 1px solid #d7e2ff;\n  border-radius: 8px;\n  background: #f9faff;\n  overflow: visible;\n}\n\n.resampling-step-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 11px 14px;\n  background: #eef2ff;\n  border-radius: 8px 8px 0 0;\n  border-bottom: 1px solid #d7e2ff;\n  font-weight: 600;\n  font-size: 13.5px;\n}\n\n.resampling-step-title {\n  font-size: 13.5px;\n  font-weight: 600;\n  color: #1c2b61;\n}\n\n/* ─── Step params ─────────────────────────────────── */\n.resampling-step-params {\n  padding: 12px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.resampling-param-row {\n  display: grid;\n  grid-template-columns: 160px 1fr;\n  align-items: center;\n  gap: 12px;\n  font-size: 13px;\n}\n\n.resampling-param-row label {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-weight: 500;\n  color: #333;\n  white-space: nowrap;\n}\n\n.resampling-param-row select,\n.resampling-param-row input[type='number'] {\n  padding: 6px 10px;\n  border: 1px solid #cdd6f0;\n  border-radius: 6px;\n  font-size: 13px;\n  background: #fff;\n  color: #222;\n  min-width: 0;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.resampling-param-row select:focus,\n.resampling-param-row input[type='number']:focus {\n  outline: none;\n  border-color: #5272c2;\n  box-shadow: 0 0 0 3px rgba(82, 114, 194, 0.15);\n}\n\n/* ─── Footer ──────────────────────────────────────── */\n.resampling-modal-footer {\n  padding: 14px 20px;\n  border-top: 1px solid #e9ecef;\n  background: #f5f7fb;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n}\n\n.resampling-footer-buttons {\n  display: flex;\n  gap: 10px;\n}\n\n.resampling-btn-cancel {\n  padding: 8px 18px;\n  border: 1px solid #cdd6f0;\n  border-radius: 6px;\n  background: #fff;\n  font-size: 13.5px;\n  font-weight: 500;\n  color: #4a4a6a;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.resampling-btn-cancel:hover {\n  background: #eef2ff;\n}\n\n.resampling-btn-apply {\n  padding: 8px 22px;\n  background: #1c2b61;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  font-size: 13.5px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.resampling-btn-apply:hover {\n  background: #2a3f8f;\n}\n\n.resampling-btn-apply:disabled {\n  background: #9aa5c8;\n  cursor: not-allowed;\n}\n\n/* ─── Body scroll lock ────────────────────────────── */\nbody.resampling-modal-open {\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
